// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calc-filter label[data-v-f635629a]{color:#444;text-align:left;font-size:15px;font-weight:400;display:block}@media (width<=419px){.calc-filter label[data-v-f635629a]{font-size:14px}}.gray-bg .calc-filter label[data-v-f635629a]{color:#787878;margin-bottom:15px;font-family:Source Sans Pro,sans-serif;font-size:17px;font-weight:700}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
